import * as React from "react";
import { useHistory } from "react-router-dom";
import { View } from "react-native";
import { allRoutesNames as routeNames } from "@timhortons/common/src/utils/allRouteNames";
import MapRoutes from "./mapRoutes";
import iamRouter from "@timhortons/web/src/modules/iam/navigation/iamRouter";
import tcnpp from "modules/tc&pp";
import { ContactUs } from "modules/contactUs";
export const publicRoutes = () => {
  return [
    {
      path: routeNames.CONTACT,
      component: ContactUs,
      isExact: true
    },
    {
      path: routeNames.ABOUTUS,
      component: () => <View>About</View>,
      isExact: true
    },
    {
      path: routeNames.PRIVACY,
      component: tcnpp,
      isExact: true
    }
    // {
    //   path: routeNames.LOGIN,
    //   component: Login,
    //   isExact: true
    // },
    // {
    //   path: routeNames.HOME,
    //   component: () => (

    //   ),
    //   isExact: true
    // },
  ];
};
export default function PublicRouter(): React.ReactElement {
  let finalPublicRoutes: Array<any> = [...publicRoutes(), ...iamRouter()];
  const history = useHistory();
  return (
    <View style={{ height: "100vh" }}>
      <MapRoutes history={history} routes={finalPublicRoutes} basePath="" />
    </View>
  );
}
